import { request } from "../../utils/request";

// 后端接口：/admin-api/video/task/list
// 请求参数（query 参数）：
// - seriesId: 剧集 id (number)
// - langCode: 剧集目标语言语种 (string)
// - sort: 排序规则 (number) - 1: 按创建时间倒序, 2: 按名称升序
// 响应数据结构：
// {
//   code: number,
//   data: Array<{
//     id: number;
//     name: string;
//     status: number;
//     coverUrl: string;
//     tag: number;
//     fileUrl: string;
//     pureVideoUrl: string;
//     resultUrl: string;
//     duration: number;
//     createTime: string;
//     updateTime: string;
//   }>,
//   msg: string
// }
export const getTaskListApi = async (params: { seriesId: number; langCode: string; sort?: number; name?: string }): Promise<Task.GetTaskListResult> => {
  // GET 请求使用 query 参数（params），form-data 参数会作为 URL 查询参数传递
  const requestParams: { seriesId: number; langCode: string; sort?: number; name?: string } = {
    seriesId: params.seriesId,
    langCode: params.langCode,
  };
  if (params.sort !== undefined) {
    requestParams.sort = params.sort;
  }
  if (params.name && params.name.trim()) {
    requestParams.name = params.name.trim();
  }

  const response = await request<{
    code: number;
    data: Array<{
      id: number;
      name: string;
      status: number;
      coverUrl: string;
      tag: number;
      fileUrl: string;
      pureVideoUrl: string;
      resultUrl: string;
      duration: number;
      createTime: string;
      updateTime: string;
    }>;
    msg: string;
  }>("/video/task/list", {
    method: "GET",
    params: requestParams,
  });

  const list = response.data || [];

  // 适配新接口到旧的 Task.TaskItem / Task.GetTaskListResult 结构
  const convertedTasks: Task.TaskItem[] = list.map((item) => ({
    name: item.name,
    disable_bgm: false,
    has_user_srt: false,
    has_user_script: false,
    tag: item.tag,
    descript: null,
    id: item.id,
    series_id: params.seriesId,
    user_id: 0,
    status: item.status,
    create_time: item.createTime,
    update_time: item.updateTime,
    file_url: item.fileUrl,
    source_hls_url: null,
    result_url: item.resultUrl,
    translated_subtitle_url: null,
    subtitle_url: null,
    pure_video_url: item.pureVideoUrl,
    pure_video_hls_url: null,
    cover_url: item.coverUrl,
    backgroud_audio_url: null,
    script_url: null,
    // 额外字段
    duration: item.duration,
    sourceLanguage: "",
    targetLanguage: "",
    needRemovalSubtitle: false,
    episodeTasks: [],
  }));

  return {
    data: convertedTasks,
    pagination: {
      page: 1,
      per_page: convertedTasks.length,
      total: convertedTasks.length,
      pages: 1,
      has_next: false,
      has_prev: false,
      sort: "alphabet",
    },
  };
};

export const createFolderApi = (name: string, parentFolderId: number) => {
  return request<Task.CreateFolderResult>("/folders/add", {
    method: "POST",
    body: {
      name,
      parentFolderId,
    },
  });
};

export const deleteFolderApi = (series_id: number) => {
  // 新接口：/admin-api/video/series/delete，使用 Params 参数 seriesId
  return request(`/video/series/delete`, {
    method: "DELETE",
    params: {
      seriesId: series_id,
    },
  });
};

